
import { Vue, Component, Prop } from "vue-property-decorator";
import Modal from "./";

@Component({
  name: "MainLoader"
})
export default class MainLoader extends Vue {
  visible: boolean = false;
  beforeMount() {
    Modal.event.$on("show", this.show);
    Modal.event.$on("hide", this.hide);
  }

  show(text: string, type: string, size: string = "sm") {
    this.visible = true;
  }
  hide() {
    this.visible = false;
  }
}
